import { SHOW_NOTIFICATION, NOTIFICATION_SHOWN, HIDE_NOTIFICATION } from '../types';

export default (state = false, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return action.payload;
    case NOTIFICATION_SHOWN:
      return false;
    case HIDE_NOTIFICATION:
      return { type: 'off', message: ''};
    default:
      return state;
  }
}